import { render, staticRenderFns } from "./MessageText.vue?vue&type=template&id=19281684&scoped=true&"
import script from "./MessageText.vue?vue&type=script&lang=ts&"
export * from "./MessageText.vue?vue&type=script&lang=ts&"
import style0 from "./MessageText.vue?vue&type=style&index=0&id=19281684&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19281684",
  null
  
)

export default component.exports